import styled from 'styled-components';
import News from '@src/components/Organism/News/index';

const NewsTemplate = () => {
  return (
    <Container>
      <News />
    </Container>
  );
};

const Container = styled.div`
  background-color: #fff;
  height: 100%;
  border-radius: 10px;
`;

export default NewsTemplate;
